module.exports = __webpack_public_path__ + "img/slider-1.55c13fd4.jpg";